var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "value-array",
    class: {
      'value-array--focus': _vm.focusIndex >= 0
    }
  }, [_vm._l((_vm.value), function(item, index) {
    return _c(_vm.toType(item), {
      key: _vm.key(item) || index,
      tag: "component",
      attrs: {
        "value": item
      },
      on: {
        "focus": function($event) {
          _vm.focus(index)
        },
        "input": function($event) {
          _vm.input(index, $event)
        },
        "remove": function($event) {
          _vm.remove(index)
        }
      }
    })
  }), _vm._v(" "), _c('button', {
    staticClass: "btn-add",
    on: {
      "click": _vm.push
    }
  }, [_vm._v("Add")])], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b5522332","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ValueArray.vue
// module id = 86
// module chunks = 1